import { cloneElement, type ReactElement } from "react";
import type { DialogBaseProps } from "../../Dialog/DialogBaseProps";

/**
 * Lazily renders a dialog tied to an external open/onOpenChange. Used by
 * Button/Badge's `dialog` prop so the dialog JSX is only
 * built when actually opened.
 *
 * When `open` flips false, this returns null and the Dialog unmounts. If the
 * dialog was open at the time, DialogModal_'s unmount cleanup pushes a closed
 * snapshot to DialogHost so the exit animation still plays — no extra slot
 * indirection needed at this layer.
 */
export function DialogMount_({
  dialog,
  open,
  onOpenChange,
}: {
  dialog: () => ReactElement<DialogBaseProps>;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  // oxlint-disable-next-line fs/no-null -- React requires null
  if (!open) return null;
  return cloneElement(dialog(), { open: true, onOpenChange });
}
